import React from 'react';
import PropTypes from 'prop-types';
// core components
import Header from '../../components/header';
import Footer from '../../components/Footer';
import MainRouter from './mainRouter';
// import { checkAuthState } from '../../utils/auth';

// Styles
// import './index.css';

const Main = class extends React.PureComponent {
  render() {
    const { router } = this.props;
    const { url } = this.props.match;

    // console.log(css);

    return (
      <>
        <Header props={this.props} />
        <MainRouter router={router} url={url} />
        <Footer />
      </>
    );
  }
};

// export default connect(state => ({
// //   isLoggedIn: checkAuthState(state)
// }))(withStyles(styles)(Main));
Main.propTypes = {
  router: PropTypes.array,
  match: PropTypes.object,
  classes: PropTypes.object,
};

export default Main;
